import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
    NgxBootstrapIconsModule,
    personCircle, list, listUl, x, search
} from 'ngx-bootstrap-icons';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ChartModule } from 'primeng/chart';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitterModule } from 'primeng/splitter';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessagesModule } from 'primeng/messages';
import { RippleModule } from 'primeng/ripple';
import { FileUploadModule } from 'primeng/fileupload';
import { StepsModule } from 'primeng/steps';
import { MenubarModule } from 'primeng/menubar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { EditorModule } from 'primeng/editor';
import {InputMaskModule} from 'primeng/inputmask';
import { TabMenuModule } from 'primeng/tabmenu';
import {ContextMenuModule} from 'primeng/contextmenu';
import { SelectButtonModule } from 'primeng/selectbutton';

import { ReportsNavComponent } from '@app/shared/features/reports/components/reports-nav/reports-nav.component';
import { ReportsPageComponent } from '@app/shared/features/reports/components/reports-page/reports-page.component';

import { LetDirective } from './directives/let.directive';
import { ClickDocumentDirective } from './directives/click-document.directive';
import { ScrollToDirective } from './directives/scroll-to.directive';
import { AvailableForDirective } from './directives/available-for.directive';

import { DropdownComponent } from './components/dropdown/dropdown.component';
import { PowerBiComponent } from './components/power-bi/power-bi.component';

import { KeyValuePipe } from './pipes/key-value.pipe';
import { UnitPipe } from './pipes/unit.pipe';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CompanyHeaderComponent } from './components/company-header/company-header.component';
import { DisableIfFormControlDirective } from './directives/disable-if';
import { UserChipComponent } from './components/user-chip/user-chip.component';
import { UserChipsComponent } from './components/user-chips/user-chips.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerInterceptor } from './Interceptors/SpinnerInterceptor';
import { ErrorInterceptor } from '@app/shared/Interceptors/error.interceptor';
import { CommentsComponent } from './components/comments/comments.component';
import { VersionHistoryComponent } from './components/version-history/version-history.component';
import { DocumentRepositoryComponent } from './components/document-repository/document-repository.component';
import { QepFileBrowserModule } from 'qep-file-browser';
import { ForecastTableComponent } from './components/forecast-table/forecast-table.component';
import { VarianceTableComponent } from './components/variance-table/variance-table.component';
import { FundsDialogComponent } from './components/funds-dialog/funds-dialog.component';
import { AddNewEventsComponent } from '@app/modules/notification/components/add-new-events/add-new-events.component';
import { DropdownModule } from 'primeng/dropdown';
import { RequiredMembersDialogComponent } from './components/required-members-dialog/required-members-dialog.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { QepButtonComponent } from './components/qep-button/qep-button.component';
import { QepDropdownComponent } from './components/qep-dropdown/qep-dropdown.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { SearchableDropdownComponent } from './components/searchable-dropdown/searchable-dropdown.component';
import { LegendsComponent } from './components/legends/legends.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { QepToggleComponent } from './components/qep-toggle/qep-toggle.component';
import { TextEditorComponent } from './components/text-editor/text-editor.component';
import { NestedDropdownComponent } from './components/nested-dropdown/nested-dropdown.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { DomainPipe } from './pipes/domain.pipe';
import { MetricComponent } from '@app/modules/companies/pages/company/components/tearsheet/components/metric/metric.component';
import { TearsheetEditDialogComponent } from './components/tearsheet-edit-dialog/tearsheet-edit-dialog.component';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { SidebarComponent } from '@app/layouts/main-layout/components/sidebar/sidebar.component';
import { PageLayoutComponent } from '@app/layouts/main-layout/components/page-layout/page-layout.component';
import { PanelModule } from 'primeng/panel';
import { UserContactListComponent } from './components/user-contact-list/user-contact-list.component';
import { AddContactComponent } from './components/add-contact/add-contact.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { UserInitialsPipe } from './pipes/user-initials.pipe';
import { ViewTasksComponent } from '@app/modules/notification/components/view-tasks/view-tasks.component';

const directives = [
    LetDirective,
    ClickDocumentDirective,
    ScrollToDirective,
    AvailableForDirective,
    DisableIfFormControlDirective
];

const components = [
    DropdownComponent,
    PowerBiComponent,
    ReportsNavComponent,
    ReportsPageComponent,
    FileUploadComponent,
    UserChipComponent,
    UserChipsComponent,
    CommentsComponent,
    VersionHistoryComponent,
    DocumentRepositoryComponent,
    ForecastTableComponent,
    VarianceTableComponent,
    FundsDialogComponent,
    AddNewEventsComponent,
    RequiredMembersDialogComponent,
    QepButtonComponent,
    QepDropdownComponent,
    UserDetailsComponent,
    SearchableDropdownComponent,
    LegendsComponent,
    QepToggleComponent,
    TextEditorComponent,
    UnauthorizedComponent,
    MetricComponent,
    TearsheetEditDialogComponent,
    SidebarComponent,
    PageLayoutComponent,
    UserContactListComponent,
    AddContactComponent,
    ViewTasksComponent
];

const pipes = [
    UnitPipe,
    DomainPipe,
    UserInitialsPipe,
    KeyValuePipe
];

const modules = [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    MenuModule,
    TableModule,
    TabViewModule,
    TabMenuModule,
    DialogModule,
    TooltipModule,
    ToolbarModule,
    SidebarModule,
    SplitterModule,
    ButtonModule,
    CalendarModule,
    RadioButtonModule,
    DividerModule,
    CardModule,
    CheckboxModule,
    InputTextareaModule,
    InputNumberModule,
    ChartModule,
    ChipsModule,
    ChipModule,
    MessagesModule,
    RippleModule,
    FileUploadModule,
    StepsModule,
    MenubarModule,
    ProgressSpinnerModule,
    EditorModule,
    InputMaskModule,
    ContextMenuModule,
    QepFileBrowserModule,
    SelectButtonModule,
    DropdownModule,
    InputSwitchModule,
    MultiSelectModule,
    ProgressBarModule,
    PanelModule,
    MultiSelectModule,
    PanelModule,
    NgxIntlTelInputModule
];

@NgModule({
    declarations: [
        ...directives,
        ...pipes,
        ...components,
        CompanyHeaderComponent,
        UserChipsComponent,
        FundsDialogComponent,
        AddNewEventsComponent,
        RequiredMembersDialogComponent,
        TextEditorComponent,
        NestedDropdownComponent
    ],
    imports: [
        ...modules,
        // NgxPowerBiModule,
        NgxBootstrapIconsModule.pick({
            personCircle, list, listUl, x, search
        })
    ],
    exports: [
        ...modules,
        NgxBootstrapIconsModule,

        ...directives,
        ...pipes,
        ...components,
        CompanyHeaderComponent,
        TextEditorComponent,
        NestedDropdownComponent  
    ],
    providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SpinnerInterceptor,
          multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
